import React from 'react';
import { Card, Alert, Container } from 'react-bootstrap';
import Navbar from "./navbar";
import Contact from "./Contact";
import Footer from "./Footer";
import { useAllPosts } from '../hooks/usePosts';

const AllPosts = () => {
  const { posts, loading, error } = useAllPosts();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main className="main-content">
        <Container className="py-4">
          <div className="section-header">
            <h1>All Posts</h1>
            <p>Explore posts shared by the community</p>
          </div>

          {loading && (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Loading posts...</p>
            </div>
          )}

          {error && (
            <Alert variant="danger">
              <strong>Error:</strong> {error}
            </Alert>
          )}

          {!loading && !error && posts.length === 0 && (
            <Alert variant="info">
              No posts yet. Be the first to create one!
            </Alert>
          )}

          <div className="row">
            {posts.map((post) => (
              <div key={post.id} className="col-md-6 col-lg-4 mb-4">
                <Card className="h-100">
                  <Card.Body>
                    <Card.Title>{post.title}</Card.Title>
                    <Card.Subtitle className="mb-3" style={{ color: '#8b7355', fontSize: '0.85rem' }}>
                      By {post.userName}<br />
                      {post.createdAt?.toDate().toLocaleDateString()}
                    </Card.Subtitle>
                    <Card.Text>{post.content}</Card.Text>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </Container>

        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default AllPosts;
